export default __webpack_public_path__ + "static/media/trr-drink-coffee-freshbrewed.4d78fa9c.png";